/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import o from"../../../../../Color.js";const r=new o([0,255,255]),e=1,n=.25,t=new o([0,0,0]),m=.4,p=.2;export{r as defaultColor,n as defaultFillOpacity,e as defaultHaloOpacity,t as defaultShadowColor,p as defaultShadowDifference,m as defaultShadowOpacity};
